export class List {
  page: number = 0;
  perPage: number = 10;
}

export interface NotificationRecord {
  not_id: number
  is_seen: number
  web_link: string
  created_at: string
  mobilePage: any
  is_link_refer_employee: boolean
  reference_token: string
  web_site_url: string
  message: string
  sub_title: any
  image: string
  user_name: any
}
